import { createAsyncThunk } from '@reduxjs/toolkit';
import extensionScriptsService from '../../services/api/extensionScriptsService';

export const fetchExtensionScripts = createAsyncThunk(
  'extensionScripts/fetchAll',
  async () => {
    const response = await extensionScriptsService.getAll();
    return response.data;
  }
);

export const fetchExtensionScript = createAsyncThunk(
  'extensionScripts/fetchOne',
  async (id) => {
    const response = await extensionScriptsService.getOne(id);
    return response.data;
  }
);

export const createExtensionScript = createAsyncThunk(
  'extensionScripts/create',
  async (data) => {
    const response = await extensionScriptsService.create(data);
    return response.data;
  }
);

export const updateExtensionScript = createAsyncThunk(
  'extensionScripts/update',
  async ({ id, data }) => {
    const response = await extensionScriptsService.update(id, data);
    return response.data;
  }
);

export const deleteExtensionScript = createAsyncThunk(
  'extensionScripts/delete',
  async (id) => {
    await extensionScriptsService.remove(id);
    return id;
  }
);

export const fetchVersionHistory = createAsyncThunk(
  'extensionScripts/fetchVersionHistory',
  async (id) => {
    const response = await extensionScriptsService.getVersionHistory(id);
    return response.data;
  }
);

export const revertScript = createAsyncThunk(
  'extensionScripts/revert',
  async ({ id, version }) => {
    const response = await extensionScriptsService.revert(id, version);
    return response.data;
  }
);

export const exportAllScripts = createAsyncThunk(
  'extensionScripts/exportAll',
  async () => {
    const response = await extensionScriptsService.exportAll();
    return response.data;
  }
);

export const fetchExecutionHistory = createAsyncThunk(
  'extensionScripts/fetchExecutionHistory',
  async ({ scriptId, limit = 5 }) => {
    const response = await extensionScriptsService.getExecutions(scriptId, { limit });
    return { scriptId, executions: response.data };
  }
);
